/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcSystemFamilyResponse } from '../../models/bc-system-family-response';

export interface GetSystems$Params {
  filter?: string;
}

export function getSystems(http: HttpClient, rootUrl: string, params?: GetSystems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemFamilyResponse>>> {
  const rb = new RequestBuilder(rootUrl, getSystems.PATH, 'get');
  if (params) {
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcSystemFamilyResponse>>;
    })
  );
}

getSystems.PATH = '/business-central/systems';
